module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Motherless")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#Two_33",
      "id": "Two_1"
    }
  }, [_c('i', [_vm._v("Two ")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("By car the Rincon Point beach community is about an hour ")]), _vm._v("and a half northwest of LA, but I arrive on foot, unaware of how much time has passed or which route I took to get here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The night sky is clear and sharp, and the scents of recent rain are almost as strong as the sea salt. The tiny, gated neighborhood is a quiet combination of year-round residents, snowbirds, and vacation renters. And surfers. Its crescent of rocky beach, rich with stones and real estate, juts into the Pacific just far enough to catch good, consistent waves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By day dolphins leap through the surf. At night glittering oil derricks light up the ocean horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Becker house itself is a money pit, a modified (and modified, and modified some more) cottage first built in the fifties. It hasn’t sucked up cash because it’s a problem, but because it is a disappointment. The house has failed to be a home no matter how many improvements are made, no matter how luxurious the finishing touches. It is a showcase house. A facade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is only one of many reasons why I hate it. But it’s my kids’ home. And it’s full of windows into their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A wide clay-tiled porch leads to this door. Moonlight shines "), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("down on it through a redwood frame dense with bougainvillea vines that cast lacy shadows on everything. A small circle of light over the front door illuminates the three wide steps. Marina always remembers to turn the lights on.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("She’s responsible, capable. Twenty going on forty. My beautiful girl. Came out of the womb like that and will probably have her own funeral arrangements in order before she dies of a wise old age. And you know what? She will be that way whether I succeed or fail. She doesn’t need me in the same way her brother does.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know with a sudden, strange awareness that my sixteen-year-old son is upstairs reading poetry books that he has secreted away in the crannies of his room, because he needs some area of his life to be hidden from his sister’s hovering, protective eye. It’s not that she’d object to a few poems, it’s that he wants the poetry to be his and his alone, even if thousands of people have had similar experiences reading them. Some things are just too sacred to be discussed with others.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There’s also the fact that very few sixteen-year-old guys can make loving poetry look cool. Dylan prefers the people who know him to think of him as a brainy computer builder, gamer, and programmer. A quirky recluse who is too genius to leave his house.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("I step onto the porch, which should be ocean-breeze cool, but the burnt-orange tiles are as hot as glowing coals. A soft hiss rises up beneath my feet, along with something like stage-trick fog. It seems like a warning, so I jump away and watch the smoky substance rise. It forms a barrier between me and the door before it finally dissipates. Of course. This house will be no different from the inanimate objects on the streets of LA—the fence, the newspaper box, the streetlamp. I can’t turn a doorknob any more easily ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("than I can pick up a pair of shoes. The door will deny me entrance. I’ll have to find another way in.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The voices of Marina and her friend Jade come to me from the back patio, a partially enclosed area that overlooks the private beach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How come you never talk about her?” Jade is asking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('i', [_vm._v("He")]), _vm._v(" never talks about her. I’ve tried enough times.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My daughter’s presence outside saves me. I circumvent the strangeness on the porch and go across the lawn to the brick footpath, which connects the front porch to the back patio. The path follows the front of the house and borders a small garden that Marina has planted and tended. Without the bougainvillea to shade them, the sweet peas, the snapdragons, the matilija poppies all glow in moonlight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tonight the light shines down on the memorial stone that sits among the flowers. A simple plaque mounted on granite:"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('i', [_vm._v("In Memory of Misty ")]), _c('br'), _c('i', [_vm._v("Wife, Mother, Friend ")]), _c('br'), _c('i', [_vm._v("1971–1997 ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At the back of the house, a low wall topped with an acrylic windbreak surrounds the patio. A wraparound bench holds several potted plants, interesting pieces of driftwood, and dozens of seashells, whole and broken. A low gate with a simple latch grants access to the beach. In the far corner, Dylan’s surfboard leans against the wall next to a couple of spares. Little pools of rainwater on the sandy wood slats reflect the wall-mounted floodlights. Overhead, the sunshades are retracted on their rolls and the stars shine down.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Marina and Jade sit on cushioned wicker chairs around an outdoor dining table. Marina has a dark beauty that is unapproachable when she wants it to be. Those heavily lined midnight eyes, the molasses hair that sits on her shoulders like a helmet, the velvet brows, and the Michelangelo mouth can all speak as one without uttering a word. She uses her fierce good looks to select which few people can have access to her heart.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("In spite of her name, Jade is beach-bunny plain by comparison, blond and tan and dime-a-dozen pretty. She sits with her head down, half listening to Marina, half tending to something on her phone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“. . . says there isn’t much to talk about,” Marina is saying, her back to me. Her bare feet are propped up on the wraparound bench, and she’s sipping natural soda straight from the can. “Mom committed suicide before Dylan even learned how to roll over.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jade’s eyes widen and abandon the phone. “She killed herself?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marina shrugs. “I guess she had a condition. A mental illness.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So that’s where Dylan gets his panic stuff from?” Jade asks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why not? Doesn’t your dad know for sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“As you already pointed out, we don’t talk about it. What difference would it make?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But isn’t that kind of thing genetic? If my head were screwed up, I’d want to know everything I could about why.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marina’s attention swivels toward the house, where the living room is bright but empty. She’s looking for her brother, not knowing he’s engrossed in a poem that’s inspiring him with a new game concept. She lowers her voice.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“Dylan’s not screwed up, okay? He’s actually really high-functioning.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I just meant it’s a good idea to know your medical history.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He worries about enough already. What good would it do if he started thinking he was his own worst enemy?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Doesn’t he already?” Jade frowns at her phone. “Suicide is so sad. Aren’t you even a tiny bit curious?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marina takes another drink and stares at the dark waters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jade sniffs. “Your dad still wears his wedding ring. He doesn’t even "), _c('i', [_vm._v("date.")]), _vm._v(" You’d think he’s still madly in love with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Jade!” Marina laughs. She pulls her feet off the bench and leans in to the table toward her friend. “You have a sick crush on my dad!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, I just think it’s weird he doesn’t talk about your mom. If I were crazy in love with a dead person I’d—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, you’re not, or you’d know how much it hurts. Him and everyone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marina’s laugh is gone. Her warning is clear, but Jade’s head must be full of air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“C’mon, Marina. You told me you don’t even have a "), _c('i', [_vm._v("picture")]), _vm._v(" of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My daughter’s back stiffens and she pushes her soda aside. It’s true, what Jade said about the pictures—and the letters, and the mementos, all of it—and the reason they are gone pains me too. It’s nobody’s business, though. Definitely not Jade’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still, Marina lets her off the hook. Sort of.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“When do you leave for Jakarta?” Marina asks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Three weeks from Monday.” Jade grins. “If I decide to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If? I thought it was all set.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know. You’re not going. I still have to come up with that last payment. I met a guy.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“A guy.” Marina scoffs. “You’d give up the trip of a lifetime for a guy?”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t know if I’d call sleeping on dirt floors and helping to vaccinate snotty kids ‘the trip of a lifetime.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, you probably wouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He runs an auto shop up in Goleta. Says business has been really great and he can give me some work. Worst-case scenario, I’ll scrape together enough for the last bill. But who knows? If he and I click, if the money’s good, maybe I’ll stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah, stay for all those broken-down cars. What’s a few kids on the other side of the world?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jade reaches out across the table and gives Marina a playful shove. “You’re the one who really cares about that sort of thing. It should be you on that plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Too late. No money. Work. You know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, I don’t. Your dad’s loaded. Unlike my delinquent parent, who dares to call herself my mother just because we live at the same address.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You assume a lot. And your mom tries.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Then Dylan must be your real excuse. Are you turning into an agoraphobe too? Seriously, Marina. He’s sixteen, old enough to snap out of it so you can have a life. When’s he going to get a job? Even a driver’s license would be an improvement!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Marina sighs. “He gets paid for some of his computer stuff. And if you had a brother with special needs maybe you’d understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The problem as I see it isn’t that Jade doesn’t have a brother, but that Marina doesn’t have a mother. She’s had to be both mother and sister since she was three. She has special needs even "), _c('i', [_vm._v("she")]), _vm._v(" doesn’t know about.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("The gate on the enclosed patio is shut. I stand there, as invisible ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("to those girls as I am to everyone else, and place my hand on the Plexiglas. My fingertips flatten against the surface, but when I lift them away, my palm leaves no mark. No fleeting moisture, no oily smudge.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The sound of a car pulling into the driveway at the front of the house reaches my ears. Immediately I know who it is. Police officers, arriving with terrible news. I didn’t get here soon enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s Dad.” Marina pushes off the table and stands, blessedly ignorant for just one minute more, and collects her empty soda can. “I’m going to warm up some dinner for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Doesn’t he know how to operate a microwave?” Jade teases.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is that your way of offering to do it?” Marina grins and waggles her eyebrows before going inside. I make note of her smile and wonder how long it will be before I see it again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I want to save her from this crushing blow, so I try to call her name. “Marina!” But my voice seizes up the way it does in nightmares, straining and soundless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The black-soled steps of authorities drum a death march on the red-tiled porch. See, already I’ve messed this up. I should have gone to Sara first, then found a way to get her here. She could have been here when the kids got the news.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a time when Sara Rochester cared for my children just because I needed her to. She might have even loved them. I never asked. She never said. We didn’t have time before the suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe there’s time now.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec658a3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter7.vue
// module id = 90
// module chunks = 0